// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"file-code-1"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M4 22H20V8H14V2H4V22Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M14 2V8H20M14 2H15L20 7V8M14 2H4V22H20V8","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M9.7929 15.7931L8 14.0002L9.79289 12.2073M14.2069 15.7931L15.9998 14.0002L14.207 12.2073","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-file-code-1')
export default class FileCode1Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'file-code-1',
    }
  }
}
